export default __webpack_public_path__ + "static/media/AVAX.a3f3731d.svg";